(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/authenticate/assets/javascripts/utils/url-utils.js') >= 0) return;  svs.modules.push('/components/accountservices/authenticate/assets/javascripts/utils/url-utils.js');

'use strict';

const isNativeApp = svs.core && svs.core.config && svs.core.config.data && svs.core.config.data.svsconfig && svs.core.config.data.svsconfig.isNativeApp;
const logger = svs.core.log.getLogger('accountservices:authenticate');
function getReturnUrl() {
  const userAgentFamily = svs.accountservices.authenticate.data.useragent_family;
  let returnUrl;
  if (svs.core.detect.browser.crios()) {
    if (window.location.protocol.indexOf('s') > -1) {
      returnUrl = 'googlechromes://';
    } else {
      returnUrl = 'googlechrome://';
    }
  } else if (svs.core.detect.os.iOS()) {
    const isNativePokerLogin = Boolean(svs.utils.cookie.read('is-native-poker-login'));
    if (isNativePokerLogin) {
      returnUrl = encodeURIComponent('svenskaspel-poker://');
    } else if (isNativeApp) {
      returnUrl = encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutikenlb.bankid'));
    } else if (userAgentFamily.indexOf('firefox') > -1) {
      returnUrl = encodeURIComponent("firefox://open-url?url=".concat(svs.utils.url.currentUrlEncodedParams()));
    } else if (userAgentFamily.indexOf('safari') > -1) {
      returnUrl = encodeURIComponent(svs.utils.url.currentUrlEncodedParams());
    } else {
      returnUrl = 'null';
    }
  } else {
    returnUrl = 'null';
  }
  logger.debug("Bankid return url: ".concat(returnUrl));
  return returnUrl;
}
function getBankIDAppUrl(autoStartToken, isQr) {
  let url;
  const isNativePokerLogin = Boolean(svs.utils.cookie.read('is-native-poker-login'));
  if (isQr) {
    url = "bankid:///?autostarttoken=".concat(autoStartToken);
  } else if (svs.core.detect.os.iOS() && !isNativeApp && !isNativePokerLogin) {
    url = "https://app.bankid.com/?autostarttoken=".concat(autoStartToken, "&redirect=").concat(getReturnUrl());
  } else if (svs.core.detect.formfactor.desktop()) {
    url = "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=null");
  } else {
    url = "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=").concat(getReturnUrl());
  }
  logger.debug("Bankid start url: ".concat(url));
  return url;
}
function getFrejaEidAppUrl(authRef) {
  let url;
  if (svs.core.detect.os.android()) {
    url = "frejaeid://bindUserToTransaction?transactionReference=".concat(authRef);
  } else if (svs.core.detect.formfactor.desktop() && !svs.core.detect.os.iOS()) {
    url = "frejaeid://bindUserToTransaction?transactionReference=".concat(authRef);
  } else {
    url = "frejaeid://bindUserToTransaction?transactionReference=".concat(authRef, "&originAppScheme=").concat(getReturnUrl());
  }
  logger.debug("Freja eID start url: ".concat(url));
  return url;
}
svs.accountservices.authenticate.utils.url = {
  getBankIDAppUrl,
  getFrejaEidAppUrl
};

 })(window);